export const images = {
  logo: "https://cdn.magicpatterns.com/uploads/xuATogRx2wpgNSvSwWFbQK/lift-off-logo-transparent.png",
  scene: "https://cdn.magicpatterns.com/patterns/generated-images/3998e5bf-a9f0-4526-bd86-d698bb6451f2.jpg",
  // Grader shot on a magenta chroma-key backdrop for a clean cut-out.
  grader: "https://cdn.magicpatterns.com/patterns/generated-images/a6d8102c-9970-4d07-a6c0-41b6077ee5a4.jpg",
  sceneWithGrader: "https://cdn.magicpatterns.com/patterns/generated-images/25d16d11-bee7-417a-bc85-498e14d6f7d7.jpg",
};
